<template>
  <div style="background-color: var(--bgColorHome); width: 100%; height: 100%;">
    <div>
      <img class="banner" :src="bannerLink"/>
    </div>
    <div class="content">
      <img :src="bgLink" style="width: 100%;" />
      <div class="menuList">
        <div class="menu" v-for="(item, index) in menuLink">
          <img :src="item.content" style="width: 100%;" v-on:click="openMenu(item,index)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'home',
    computed: {
      bannerLink: function(){
        return menuListLinkConfigHome.banner;
      },
      bgLink: function(){
         return commonLinkConfig.bg;
      },
      menuLink: function(){
         return menuListLinkConfigHome.cases;
      }
    },
    methods:{
      openMenu: function(item,index){
        if(item.inRouter){
          //路由表内部
          this.$router.push({name:item.route,params:{index:index}});
        }else{
          //页面跳转
          location.href=item.route;
        }
      }
    }
  }
</script>

<style scoped>
  .banner{
    width: 100%;
    vertical-align: bottom;
  }
  .content{
    position: relative;
  }
  .menuList{
    width: 75%;
    position: absolute;
    top: 5%;
    left: 50%;
    transform: translateX(-50%);
  }
  .menu{
    width: 100%;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue